export type VersionKey = 'dev' | 'staging' | 'prod'
export const version: VersionKey = 'prod'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const isNotProd = version !== 'prod'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const isDev = version === 'dev'

export const releaseDate = '2026-08-18 18:09:37'

export const v106releaseDate = new Date('2025-11-05T00:00:00.000Z').getTime()

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const GYN_ENABLED = version === 'dev'
